import { runOnFeatureInit } from '@frontend/vanilla/core';

import { WidgetRegistrationService } from './widget-registration.service';

export function provide() {
    return [runOnFeatureInit(WidgetRegistrationService)];
}
